// SOMA mark geometry, taken from SOMA-frontend/public/icons/logo-icon.svg (viewBox 848×800).
// Shared by the SVG logo and the 3D mark in the gyroscope so the two never drift apart.

export const LOGO_VIEWBOX = { width: 848, height: 800 } as const;

export const LOGO_DOT_R = 106.922;

export const LOGO_DOTS: readonly (readonly [number, number])[] = [
  [298.643, 691.589],
  [106.922, 422.43],
  [527.235, 108.411],
  [741.078, 422.43],
  [210.157, 108.411],
  [424, 422.43],
];

/**
 * The two connector shapes, each: move, cubic, line, cubic, close.
 * [mx,my, c1x,c1y, c2x,c2y, x,y, lx,ly, c3x,c3y, c4x,c4y, x2,y2]
 */
export const LOGO_LINKS: readonly (readonly number[])[] = [
  [760.337, 315.791, 649.603, 295.234, 612.134, 240.212, 632.409, 127.937, 507.979, 215.05, 618.712, 235.607, 656.181, 290.629, 635.906, 402.905],
  [443.258, 315.791, 332.525, 295.234, 295.056, 240.212, 315.331, 127.937, 190.901, 215.05, 301.634, 235.607, 339.103, 290.629, 318.828, 402.905],
];

/** SVG path data for one connector. */
export function linkPath(q: readonly number[]): string {
  return `M${q[0]} ${q[1]}C${q[2]} ${q[3]} ${q[4]} ${q[5]} ${q[6]} ${q[7]}L${q[8]} ${q[9]}C${q[10]} ${q[11]} ${q[12]} ${q[13]} ${q[14]} ${q[15]}Z`;
}
